// Custom Manufacturing page Indonesian translations

export default {
  pageTitle: "Manufaktur Kustom",
  breadcrumbHome: "Beranda",
  breadcrumbServices: "Layanan",
  breadcrumbCurrent: "Manufaktur Kustom",
  
  // Service links
  customManufacturing: "Manufaktur Kustom",
  technicalSupport: "Dukungan Teknis",
  afterSalesService: "Layanan Purnajual",
  qualityAssurance: "Jaminan Kualitas",
  researchDevelopment: "Penelitian & Pengembangan",
  globalSupplyChain: "Rantai Pasokan Global",
  
  // Main content
  title: "Solusi Manufaktur Kustom",
  description1: "Di PT Eagle Industry Indonesia, kami mengkhususkan diri dalam menyediakan solusi manufaktur kustom yang disesuaikan untuk memenuhi persyaratan unik klien kami di berbagai industri. Kemampuan manufaktur canggih dan tim rekayasa berpengalaman kami memungkinkan kami untuk mengirimkan komponen presisi berkualitas tinggi yang sesuai dengan spesifikasi Anda.",
  description2: "Dengan pengalaman puluhan tahun dalam manufaktur presisi, kami telah mengembangkan keahlian dalam memproduksi komponen mekanis kompleks yang memenuhi standar industri yang paling menuntut. Proses manufaktur kustom kami menggabungkan teknologi mutakhir dengan kerajinan tradisional untuk memastikan kualitas dan kinerja yang luar biasa.",
  
  // Capabilities section
  capabilitiesTitle: "Kemampuan Manufaktur Kustom Kami:",
  capabilities: [
    "Pemesinan presisi dengan toleransi seketat ±0.001mm",
    "Seleksi dan sumber material kustom berdasarkan persyaratan aplikasi",
    "Pengembangan prototipe dan iterasi cepat untuk optimasi desain",
    "Kemampuan produksi dari batch kecil hingga volume besar",
    "Geometri kompleks dan kemampuan pemesinan multi-sumbu",
    "Proses perawatan permukaan dan finishing untuk meningkatkan kinerja"
  ],
  
  // Industry applications
  industryApplicationsTitle: "Aplikasi Industri:",
  industryApplications: "Solusi manufaktur kustom kami melayani berbagai industri, termasuk otomotif, dirgantara, kelautan, minyak dan gas, manufaktur semikonduktor, dan mesin industri. Kami memahami tantangan dan persyaratan unik setiap industri dan mengembangkan solusi kustom yang mengatasi kebutuhan operasional spesifik.",
  
  // Metrics
  manufacturingPrecision: "Presisi Manufaktur",
  manufacturingPrecisionDesc: "Toleransi dan standar kualitas terkemuka di industri",
  materialExpertise: "Keahlian Material",
  materialExpertiseDesc: "Berbagai macam material termasuk paduan khusus",
  productionFlexibility: "Fleksibilitas Produksi",
  productionFlexibilityDesc: "Solusi skalabel dari prototipe hingga produksi massal",
  qualityAssuranceMetric: "Jaminan Kualitas",
  qualityAssuranceMetricDesc: "Proses pengujian dan inspeksi yang ketat",
  
  // Process section
  processTitle: "Proses Manufaktur Kami:",
  processDescription: "Proses manufaktur kustom kami dimulai dengan pemahaman menyeluruh tentang persyaratan dan tantangan aplikasi Anda. Tim rekayasa kami berkolaborasi erat dengan klien untuk mengembangkan spesifikasi detail dan optimasi desain. Kemudian kami memanfaatkan fasilitas manufaktur canggih kami untuk memproduksi komponen yang memenuhi spesifikasi tepat, diikuti dengan pengujian kualitas komprehensif untuk memastikan kinerja dan keandalan.",
  
  // CTA button
  discussRequirements: "Diskusikan Persyaratan Kustom Anda",
  
  // Related services section
  relatedServicesTitle: "Layanan Terkait",
  relatedServicesDescription: "Jelajahi layanan komprehensif lainnya",
  technicalSupportDesc: "Bantuan teknis ahli untuk memastikan kinerja optimal produk kami.",
  qualityAssuranceDesc: "Proses kontrol kualitas ketat memastikan kepatuhan standar internasional.",
  researchDevelopmentDesc: "Inovasi berkelanjutan untuk mengembangkan solusi pengecatan lanjutan.",
  readMore: "Baca selengkapnya"
};